<template>
  <header class="main-container">
    <div class="row" :class="rowClasses">
      <div class="col myHeaderImage">
        <div v-if="header.logo" class="logo-holder" :class="logoAlignment">
          <h1>
            <img :style="{ height: `${header.logoSize}px` }" :src="header.logo" :alt="header.alt" />
          </h1>
        </div>
        <div v-else class="logo-holder">
          <h1 style="justify-content: center;">
            {{ header.alt }}
          </h1>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: "Header",
  props: {
    header: Object,
  },
  computed: {
    rowClasses() {
      if (!this.header.hasHero) {
        return "no-hero";
      }
    },
    logoAlignment() {
      switch (this.header.logoAlignment.toLowerCase()) {
        case "center":
          return "logo-center";
        case "right":
          return "logo-right";
        default:
          return "logo-left";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.row {
  &.no-hero {
    padding-bottom: 0;
  }
  .myHeaderImage {
    font-family: var(--micrositeTypeStyle);
    padding: 0;
  }
}

header.main-container {
  padding: 0 40px;

  @include media-breakpoint-down(md) {
    padding: 0 30px;
  }
}

.logo-holder {
  &.logo-center {
    h1 {
      justify-content: center;
    }
  }

  &.logo-right {
    h1 {
      justify-content: flex-end;
    }
  }

  h1 {
    font-size: 40px;
    font-weight: bold;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    color: var(--secondaryText);
  }

  img {
    min-height: 40px;
    max-height: 100px;

    @include media-breakpoint-down(md) {
      // height: unset !important;
      // min-height: 100% !important;
      // max-height: unset !important;
      // width: 100% !important;
    }
  }
}
</style>
